import React from 'react';
import { Sparkles, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { useLang } from '../context/LanguageContext';

const CARD_BG = "radial-gradient(circle at 30% 30%, rgba(212,175,55,0.15) 0%, transparent 50%), radial-gradient(circle at 70% 70%, rgba(139,92,246,0.15) 0%, transparent 50%), linear-gradient(135deg, #1a0a2e 0%, #0d0520 50%, #1a0a2e 100%)";

export default function TarotSection() {
  const { lang } = useLang();

  return (
    <section className="section-padding cosmic-bg" id="tarot" data-testid="tarot-section">
      <div className="container-custom">
        <div className="text-center mb-10">
          <span className="text-xs tracking-[0.3em] uppercase text-gold font-semibold">
            {lang === 'hi' ? 'दैनिक टैरो रीडिंग' : 'Daily Tarot Reading'}
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl text-text-main mt-3">
            {lang === 'hi' ? 'आज का टैरो कार्ड' : "Today's Tarot Card"}
          </h2>
          <p className="text-text-muted mt-3 max-w-lg mx-auto">
            {lang === 'hi'
              ? '3 कार्ड निकालें — अतीत, वर्तमान और भविष्य जानें वैदिक उपाय सहित'
              : 'Draw 3 cards — Discover Past, Present & Future with Vedic remedies'}
          </p>
          <div className="divine-divider mt-6 max-w-xs mx-auto" />
        </div>

        {/* Cards Preview */}
        <div className="flex justify-center gap-4 sm:gap-6 mb-8">
          {['अतीत', 'वर्तमान', 'भविष्य'].map((label, i) => (
            <motion.div key={i} className="flex flex-col items-center gap-2"
              initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }} transition={{ delay: i * 0.2 }}>
              <motion.div
                className="w-[90px] h-[135px] sm:w-[110px] sm:h-[165px] rounded-xl border-2 border-gold/25 flex items-center justify-center overflow-hidden cursor-pointer"
                style={{ background: CARD_BG }}
                animate={{ y: [0, -6, 0] }}
                transition={{ duration: 3, repeat: Infinity, delay: i * 0.4, ease: "easeInOut" }}
                whileHover={{ scale: 1.08 }}>
                <div className="absolute inset-2 border border-gold/15 rounded-lg" />
                <span className="text-3xl sm:text-4xl text-gold/25">ॐ</span>
              </motion.div>
              <span className={`text-xs font-semibold tracking-wider ${
                i === 0 ? 'text-blue-400' : i === 1 ? 'text-gold' : 'text-purple-400'
              }`}>
                {lang === 'hi' ? label : ['Past', 'Present', 'Future'][i]}
              </span>
            </motion.div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <a href="/daily-tarot" className="btn-gold inline-flex items-center gap-2 text-base" data-testid="tarot-cta-btn">
            <Sparkles className="w-5 h-5" />
            {lang === 'hi' ? 'अपना टैरो कार्ड निकालें' : 'Draw Your Tarot Cards'}
            <ArrowRight className="w-5 h-5" />
          </a>
          <p className="text-text-muted text-xs mt-3">
            {lang === 'hi' ? 'रोज़ नई रीडिंग — बिल्कुल Free' : 'New reading every day — Absolutely Free'}
          </p>
        </div>
      </div>
    </section>
  );
}
